import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { FileUploadIcon } from "../../../components/icons/SvgIcons";
import { getRegistro } from "../../../redux/actions";
import * as XLSX from "xlsx";
import { useState } from "react";
import Button from "../../../components/button";
import { formatFechaHora } from "../../../utils/formatDate";


function TiempoReporteModal({ onClose, currentFilter }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        register,
        handleSubmit,
    } = useForm();

    const normalizeFilterForFilename = (filter) => {
        return filter
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^\w_]/g, "");
    };


    const handleDownloadExcel = async (periodoMeses) => {
        setLoading(true);

        const today = new Date();
        const endDate = today.toISOString().split("T")[0];

        let startDate;

        if (currentFilter === "a compactar") {
            // Caso especial: histórico completo
            startDate = "2015-01-01";
        } else {
            const pastDate = new Date();
            pastDate.setMonth(pastDate.getMonth() - periodoMeses);
            startDate = pastDate.toISOString().split("T")[0];
        }

        const filterMap = {
            ingresados: "Ingresado",
            egresados: "Egresado",
            "a compactar": "A compactar",
            compactados: "Compactado",
        };

        const data = {
            startDate,
            endDate,
            estado: filterMap[currentFilter] || currentFilter,
            sector: "todos",
            tipovh: "todos",
            user: "todos",
        };

        const response = await dispatch(getRegistro(data));

        if (!response || response.length === 0) {
            setError("No hay registros para el período seleccionado.");
            setLoading(false);
            return;
        }


        // Convertir datos a formato compatible con Excel
        const registro = response.map((item) => ({
            "Nro Acta": item.Acta?.nro || "Sin Acta",
            "Fecha y Hora de Ingreso": formatFechaHora(item.fecha_hora, "Sin fecha"),
            "Sector": item.sector || "Sin sector",
            "Usuario": item.User?.nombreCompleto || "Sin usuario",
            "Dominio": item.Vehiculo?.dominio || "Sin dominio",
            "Marca": item.Vehiculo?.marcavh || "Sin marca",
            "Modelo": item.Vehiculo?.modelovh || "Sin modelo",
            "Estado": item.estado || "Desconocido",
            "Fecha y Hora de Egreso": item.Egreso?.fecha_hora ? formatFechaHora(item.Egreso.fecha_hora) : "No egresado",
            "Usuario que Egresó": item.Egreso?.User?.nombreCompleto || "Desconocido",
            "Usuario que Compactó": item.Compactado?.User?.nombreCompleto || "Desconocido",
            "Fecha y Hora de Compactación": item.Compactado?.fecha_hora ? formatFechaHora(item.Compactado.fecha_hora) : "No compactado",
            "Fecha y Hora de Creación de Acta": item.Acta?.fecha_hora ? formatFechaHora(item.Acta.fecha_hora) : "Sin fecha de acta",
        }));

        // Crear hoja de trabajo y libro de Excel
        const ws = XLSX.utils.json_to_sheet(registro);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Registros");

        const safeFilter = normalizeFilterForFilename(currentFilter);

        const fileName = `Registros_${safeFilter}_ultimos_${periodoMeses}_meses.xlsx`;

        // Descargar el archivo
        XLSX.writeFile(wb, fileName);

        setLoading(false)
    };

    const onSubmit = async (data, event) => {
        event.preventDefault();
        handleDownloadExcel(Number(data.periodo));
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={onClose} /* Cierra al hacer clic fuera */
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
                onClick={(e) =>
                    e.stopPropagation()
                } /* Evita que el clic dentro lo cierre */
            >
                <div className="relative w-[20rem] bg-white p-6 rounded-lg shadow-lg">
                    <button
                        onClick={onClose}
                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                    >
                        ✕
                    </button>
                    <div className="text-2xl font-bold mb-4 text-center">
                        Descargar Excel
                    </div>
                    <div className="mb-4">
                        {/* Contenido del formulario */}
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Periodo
                        </label>
                        <select
                            className="w-full p-2 border rounded"
                            {...register("periodo", {
                                required: "Seleccione un período por favor",
                            })}
                        >
                            {[...Array.from({ length: 12 }, (_, i) => i + 1), 18, 24].map((meses) => (
                                <option key={meses} value={meses}>
                                    {meses} {meses === 1 ? "mes" : "meses"}
                                </option>
                            ))}
                        </select>

                    </div>
                    <div className="flex flex-col justify-center gap-4">
                        <Button
                            type="submit"
                            fullWidth
                            loading={loading}
                            icon={<FileUploadIcon className="size-6" />}
                        >
                            Descargar
                        </Button>
                        <Button
                            variant="secondary"
                            fullWidth
                            onClick={onClose}
                        >
                            Cancelar
                        </Button>
                    </div>
                    {error && (
                        <p className="text-sm text-red-600 text-center mb-2 mt-4">
                            {error}
                        </p>
                    )}
                </div>
            </form>
        </div>
    );
}

export default TiempoReporteModal;
